/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthLoginRequest, AuthLoginResponse } from '../types/AuthLogin'

/**
 * POST /auth/login
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::login
 */
export async function authLogin(
	data: AuthLoginRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthLoginResponse>> {
	return axiosInstance.post('/auth/login', data, config)
}
